const qs = require("qs");

// json格式
export const ContentTypeJson = function (data) {
    return {
        data: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json"
        }
    }
}

// form表单格式
export const ContentTypeForm = function (data) {
    return {
        data: qs.stringify(data, {
            arrayFormat: "repeat",
        }),
    }
}
